import { render, staticRenderFns } from "./ModalSettings.vue?vue&type=template&id=b43cfc0a&"
import script from "./ModalSettings.vue?vue&type=script&lang=ts&"
export * from "./ModalSettings.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports